import {SET_POST} from './types';

export const setPost = payload => ({
  type: SET_POST,
  payload,
});
